// extracted by mini-css-extract-plugin
module.exports = {"modal":"SessionTimeoutModal_modal__TzDrV","closeBtn":"SessionTimeoutModal_closeBtn__1h9fS"};